import {
  CatalogAction,
  CatalogActionTypes,
  CatalogState,
} from 'store/types/catalog'
import { GenreMap } from 'models'
import { emptyGenres } from 'pages/Catalog/common'

const initialState: CatalogState = {
  catalog: [],
  total: 0,
  genres: emptyGenres,
  loading: false,
  error: null,
}

const genriesOptions = Array.from(GenreMap.entries()).map(v => ({
  value: `${v[0]}`,
  title: v[1],
}))

const getGenreArray = (genreList: number[]) => {
  const arr = genriesOptions.filter(genre =>
    genreList.includes(parseInt(genre.value, 10))
  )
  const arr2 = arr.splice(9)

  return [arr, arr2]
}

export const catalogReducer = (
  state = initialState,
  action: CatalogAction
): CatalogState => {
  switch (action.type) {
    case CatalogActionTypes.FETCH_CATALOG:
      return {
        loading: true,
        error: null,
        catalog: state.catalog,
        total: state.total,
        genres: state.genres,
      }
    case CatalogActionTypes.FETCH_CATALOG_SUCCESS:
      return {
        loading: false,
        error: null,
        catalog: action.payload.items,
        total: action.payload.total,
        genres: getGenreArray(action.payload.genres),
      }
    case CatalogActionTypes.FETCH_CATALOG_SUCCESS_MORE:
      return {
        loading: false,
        error: null,
        catalog: [...state.catalog, ...action.payload.items],
        total: action.payload.total,
        genres: getGenreArray(action.payload.genres),
      }
    case CatalogActionTypes.FETCH_CATALOG_ERROR:
      return {
        loading: false,
        error: action.payload,
        catalog: [],
        total: 0,
        genres: emptyGenres,
      }
    default:
      return state
  }
}
